import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const HeroSection = () => {
    return (
        <section id="hero" className="d-flex align-items-center">
            <div className="container">
                <div className="hero-content">
                    <p className="hero-label">ZIMBABWE HEALTHCARE SPECIALIST BOOKING</p>
                    <h1>Your Specialist, <br />One Click Away</h1>
                    <p className="hero-sub">Connect with trusted specialists, secure your appointment, and receive your invoice — seamlessly, from anywhere.</p>
                </div>
                <div className="hero-actions">
                    <Link to={'/doctors'} className="btn-get-started scrollto">Find a Specialist</Link>
                    <Link to={'/track-appointment'} className="btn-get-started btn-get-started--outline scrollto">Track Appointment</Link>
                </div>
            </div>
        </section>
    )
}
export default HeroSection;
